<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
 <g>
  <ellipse ry="9" rx="9" id="svg_1" cy="12" cx="12" stroke="#000" fill="#fff"/>
  <text font-style="normal" font-weight="normal" xml:space="preserve" text-anchor="start" font-family="'Poppins'" font-size="10" stroke-width="0" id="svg_2" y="15.74684" x="5.5" stroke="#000" fill="#000000">GF</text>
 </g>
</svg>